var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"fill-height"},[_c('v-col',{staticClass:"fill-height pb-0"},[_c('v-card',{staticClass:"fill-height actions-info",attrs:{"rounded":""}},[_c('v-card-text',[_c('player-actions2'),_c('club-info')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }